import React from 'react';
import KogInputTextOutlinedControlled from '@/main/components/shared/inputText/inputTextOutlinedControlled';
import { useFormContext, useWatch } from 'react-hook-form';
import { getTranslateByKey } from '@/main/services/utils';
import styled from 'styled-components';
import { QuoteSupplierItemPartResponse } from '@/main/models/response';
import * as S from '../../styles';

const PackageTypeArea = styled.div`
  &&& {
    .MuiInputBase-root {
      max-width: 60px;
    }
  }
  display: flex;
  width: 100%;
  flex-direction: row;
  gap: 0.3rem;
  justify-content: space-between;
`;

interface IDimensionsInputProps {
  fieldPrefix: string;
  showFieldWithouEdit?: boolean;
  row: QuoteSupplierItemPartResponse;
  dimensionsValidationError?: boolean;
}

export default function ColumnDimensions({ fieldPrefix, showFieldWithouEdit, row, dimensionsValidationError }: IDimensionsInputProps) {
  const { control } = useFormContext();

  const watcherNotQuote = useWatch({
    control,
    name: `${fieldPrefix}.notQuote`,
    defaultValue: false
  });

  if (showFieldWithouEdit) {
    return row.height && row.depth && row.width ? (
      <S.TextAlignTable>
        {row.height} x {row.width} x {row.depth}
      </S.TextAlignTable>
    ) : (
      <></>
    );
  }

  return (
    <PackageTypeArea>
      <KogInputTextOutlinedControlled
        required={!watcherNotQuote}
        id="id-createAnswer-txt-height"
        name={`${fieldPrefix}.height`}
        disabledMessage
        hasOnlyNumberInteger
        placeholder={getTranslateByKey('information.height')}
        label=""
        control={control}
        hideValue={watcherNotQuote}
        disabled={watcherNotQuote}
        controllerProps={{
          rules: {
            maxLength: 10,
            validate: value => watcherNotQuote || value > 0
          }
        }}
      />
      <KogInputTextOutlinedControlled
        required={!watcherNotQuote}
        id="id-createAnswer-txt-width"
        name={`${fieldPrefix}.width`}
        disabledMessage
        placeholder={getTranslateByKey('information.width')}
        label=""
        control={control}
        hideValue={watcherNotQuote}
        disabled={watcherNotQuote}
        controllerProps={{
          rules: {
            maxLength: 10,
            validate: value => watcherNotQuote || value > 0
          }
        }}
      />
      <KogInputTextOutlinedControlled
        required={!watcherNotQuote}
        id="id-createAnswer-txt-depth"
        name={`${fieldPrefix}.depth`}
        disabledMessage
        placeholder={getTranslateByKey('information.depth')}
        label=""
        control={control}
        hideValue={watcherNotQuote}
        disabled={watcherNotQuote}
        controllerProps={{
          rules: {
            maxLength: 10,
            validate: value => watcherNotQuote || value > 0
          }
        }}
      />
    </PackageTypeArea>
  );
}
